import moment from 'moment'

export const dateFunctionFilters = {
  filters: {
    toDateOnly: function (value) {
      if (!value || value === '-') return ''
      if (value) {
        return moment.utc(String(value)).local().format('DD.MM.YYYY')
      }
    },
    toDateTimeLocalTime: function (value) {
      if (!value || value === '-') return ''
      if (value) {
        return moment.utc(String(value)).local().format('DD.MM.YYYY HH:mm')
      }
    },
    toDateTime: function (value) {
      if (!value || value === '-') return ''
      if (value) {
        return moment(String(value)).format('DD.MM.YYYY HH:mm')
      }
    },
    toShortMonthYear: function (value) {
      if (!value || value === '-') return ''
      if (value) {
        return moment(String(value)).format('MMM YYYY')
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/mixins/dateFunctionFilters.js